import { get } from 'lodash'
import { getEngageData } from '../crud/table.crud'

const DEFAULT_PAGE = 1
const DEFAULT_PAGE_SIZE = 10000

/**
 * Fetches the employee list from the Engage employee endpoint.
 *
 * Notes:
 * - This is used across the app (Engage, Entra Groups user pickers, etc.)
 * - `license` defaults to true in `getEngageData`; pass `license: false` when you need unlicensed users too.
 */
export const fetchCustomerEngageEmployees = async ({
  customerId,
  integrationName,
  organizationId,
  requiredModules,
  license,
  select,
  page = DEFAULT_PAGE,
  pageSize = DEFAULT_PAGE_SIZE,
  filters = {},
  ignoredEmployees = null,
} = {}) => {
  if (!customerId || !integrationName || organizationId == null) {
    return []
  }

  const response = await getEngageData({
    apiUrl: `/customer/${customerId}/employee`,
    integrationApplicationId: integrationName,
    requiredModules,
    organizationId,
    page,
    page_size: pageSize,
    sort_field: null,
    sort_direction: null,
    filters,
    ignoredEmployees,
    license,
    select,
  })

  return get(response, 'data.data', []) ?? []
}
